import { Box, Modal } from "@mui/material";
/* eslint-disable max-len */
import React, { FC } from "react";
import { boxStyle, boxStyleInner } from "./ModalCustom.style";

import { MODALS } from "../../config/params";
import { useCardDetailStore } from "../../services/card-detail/card-detail.service";
import { useModal } from "../../context/ModalContext";

interface ModalCustomProps {
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
  width?: string;
}

const ModalCustom: FC<ModalCustomProps> = ({ children, open, onClose, width = 480 }) => {
  const { modalView } = useModal();
  const { setCardSelected } = useCardDetailStore();

  const handleClose = () => {
    if (modalView=== MODALS.ADD_ADDRESS || MODALS.UPDATED_BOOK_A_VISIT_MODAL || MODALS.SELECTED_TIME_UNAVAILABLE ||
      MODALS.CANCEL_BOOK_A_VISIT || MODALS.UPDATED_BOOKING_CONFIRMATION_MODAL || MODALS.WELLNESS_PLAN_PAYMENT_SUCCESS || MODALS.CALL_HOSPITAL_MODAL) {
      return undefined;
    } else if (modalView !== MODALS.ADD_PAYMENT_METHOD) {
      setCardSelected(null);
      onClose();
    } else {
      onClose();
    }
  };

  const isUserDeleteRedirect = modalView === MODALS.USER_DELETE_REDIRECT;

  const isSmallLayout =()=>{
    const largeModels = [
      MODALS.LOGOUT,
      MODALS.WELLNESS_PLAN_PAYMENT_SUCCESS,
      MODALS.OVERDUE_CONTACT_MODAL,
      MODALS.PENDING_INVOICE_ALERT_MODAL,
      MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL,
      MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL,
      MODALS.GENERIC_PAYMENT_ISSUE_MODAL,
      MODALS.DUPLICATE_ACCOUNT_ALERT_MODAL,
      MODALS.UPDATE_PAYMENT_ERROR_MODAL,
      MODALS.EXPIRED_PAYMENT_UPDATE_MODAL,
      MODALS.QUICK_SHARE_UPSELL_MODAL,
      MODALS.WELLNESS_PLAN_ENDED_ALERT,
      MODALS.WELLNESS_PLAN_RENEW_UNSUCCESSFUL_ALERT,
      MODALS.WELLNESS_PLAN_RENEWAL_SUCCESSFUL_ALERT,
      MODALS.WELLNESS_PLAN_RENEWAL_REMINDERS,
      MODALS.WELLNESS_PLAN_PAYMENT_ERROR_MODAL,
      MODALS.WELLNESS_RENEWAL_UPSELL,
      MODALS.WELLNESS_PLAN_TRANSITION_SUCCESS,
      MODALS.CANCEL_UPCOMING_PLAN_RENEWAL_SUCCESS,
      MODALS.PAYMENT_INFORMATION_MODAL,
      MODALS.SCRATCHPAY_SUCCESS_MODAL,
      MODALS.SCRATCHPAY_RENEWAL_PENDING_MODAL,
      MODALS.SCRATCHPAY_INFO_MODAL,
      MODALS.VETCOVE_REDIRECT_MODAL,
      MODALS.CUSTOMER_SUPPORT_MODAL,
      MODALS.PREQUAL_INTERCEPTOR_MODAL,
    ];

    return !largeModels.includes(modalView as string);
  };

  const customSmallModalsStyle = () => {
    const layouts = [
      MODALS.EXPIRED_PAYMENT_UPDATE_MODAL,
    ];

    return layouts.includes(modalView as string);
  };
  const ignorePadding = () => {
    const layouts = [
      MODALS.QUICK_SHARE_UPSELL_MODAL,
      MODALS.INVITE_UPSELL_MODAL,
      MODALS.WELLNESS_PLAN_RENEWAL_REMINDERS,
      MODALS.CUSTOMER_SUPPORT_MODAL,
      MODALS.SCRATCHPAY_INFO_MODAL,
      MODALS.PREQUAL_INTERCEPTOR_MODAL,
    ];

    return layouts.includes(modalView as string);
  };

  const ignoreDimensions = () => {
    const layouts = [
      MODALS.INVITE_UPSELL_MODAL,
    ];

    return layouts.includes(modalView as string);
  };

  const useReducedRadius = () => {
    const layouts = [
      MODALS.VETCOVE_REDIRECT_MODAL,
    ];

    return layouts.includes(modalView as string);
  };

  const allowOverflowScroll = () => {
    const layouts = [
      MODALS.UPDATED_BOOK_A_VISIT_MODAL,
      MODALS.URGENT_VISIT_MODAL,
      MODALS.EXPRESS_VISIT_MODAL,
      MODALS.RESCHEDULE_A_VISIT,
      MODALS.SCRATCHPAY_INFO_MODAL,
    ];

    return layouts.includes(modalView as string);
  };

  return (
    <Modal
      open={open}
      onClose={isUserDeleteRedirect ? undefined : handleClose}
    >
      <Box sx={{
        ...boxStyle,
        ...(useReducedRadius() && { borderRadius: "12px" }),
      }}
      className={isSmallLayout()?`${ignoreDimensions()?"":`w-[90%] md:w-[60%] lg:w-[35%] xl:w[30%] 2xl:w-[540px]
         h-[90vh] xl:h-[85vh] 2xl:h-[80vh] 3xl:h-[85vh] 4xl:h-[60vh] 5xl:h-[50vh]`}`:`!bg-white ${ignorePadding()?"!p-0":"p-4"} ${customSmallModalsStyle()?"!w-[28rem]":"w-[90%]"}  md:w-fit`}>
        <Box sx={{
          ...boxStyleInner,
          ...(allowOverflowScroll() && { overflowY: "auto" }),
        }} className={`!h-full ${ignorePadding()?"!p-0":"p-4"} pb-3 flex scroll-hide`} style={{ flexFlow: "column" }}>
          {children}
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalCustom;
